import { IconTicket } from "@tabler/icons-react";
import css from "./PulsarTicket.module.scss";
import { classNames } from "@greeter/util";

export function PulsarTicket() {
  return (
    <div className={css.PulsarTicket}>
      <PulsarTicket.Ring ring={3} />
      <PulsarTicket.Ring ring={2} />
      <PulsarTicket.Blur />
      <PulsarTicket.Ring ring={1} />
      <IconTicket className={css.Icon} />
    </div>
  );
}

PulsarTicket.Ring = function (props: { ring: 1 | 2 | 3 }) {
  return (
    <div
      {...classNames(
        css.Ring,
        props.ring === 1 ? css.First : props.ring === 2 ? css.Second : css.Third
      )}
    />
  );
};

PulsarTicket.Blur = function () {
  return <div className={css.Blur} />;
};
